export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BannerActions.vue?vue&type=template&id=68d28aae&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/banner/components/BannerActions.vue?vue&type=template&id=68d28aae&
// module id = 1212
// module chunks = 0